import { render } from "./HomeView.vue?vue&type=template&id=b1fec4a4"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=b1fec4a4&lang=css"

import exportComponent from "/home/christian/Trabalho/fish_coletor/Coletor-APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__